export const REFILL_MODE_TEXTS = {
    RAIL: 'Railway',
    STOCKTRANSFER: 'Stock Transfer',
};
